import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import Status from "components/base/Status";
import { useModals } from "ModalProvider";
import { Link } from "react-router-dom";
import CreateGTMProjectView from "./CreateGTMProjectView";
import { FETCH_GTM_PROJECTS } from "./graphql";

const GTMProjectsPage = () => {
  const { loading, error, data } = useQuery(FETCH_GTM_PROJECTS, {
    fetchPolicy: "network-only",
  });
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  function createNewProject() {
    modal.present({
      title: "Create New GTM Project",
      children: <CreateGTMProjectView />,
      maxWidth: "max-w-3xl",
      center: true,
    });
  }

  const activeProjects = data.gtmProjects.results.filter((i) => !i.archivedAt);
  const archivedProjects = data.gtmProjects.results.filter((i) => i.archivedAt);

  let groups = [];

  const redProjects = activeProjects.filter(
    (i) => i.startUpProject?.team === "RED",
  );
  const otherProjects = activeProjects.filter(
    (i) => i.startUpProject?.team !== "RED",
  );

  if (redProjects.length > 0) {
    groups.push({ name: "Shipped from Team Red", projects: redProjects });
  }
  if (otherProjects.length > 0) {
    groups.push({ name: "GTM Created", projects: otherProjects });
  }

  console.log("archivedProjects", archivedProjects);

  return (
    <Page
      staticHeader
      title="Go to Market Projects"
      rightButtons={
        <div>
          <Button onClick={createNewProject}>+ New GTM Project</Button>
        </div>
      }
    >
      <div className="p-6 grid grid-cols-2 gap-6">
        {data.gtmProjects.results.length > 0 ? (
          groups.map((group, groupIndex) => (
            <div className="card p-4" key={groupIndex}>
              <table>
                <thead>
                  <tr>
                    <th>{group.name} Projects</th>
                    <th className="text-right">Stage</th>
                  </tr>
                </thead>
                <tbody>
                  {group.projects.map((i, index) => (
                    <tr
                      key={index}
                      className="border-y border-gray-100 dark:border-gray-700"
                    >
                      <td>
                        <Link to={`${i.id}`}>{i.name}</Link>
                      </td>
                      <td>
                        <div className="flex justify-end -mx-2">
                          <Status status={i.state} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <div className="py-2 opacity-70">
            No projects at the moment. You can create a new one directly or from
            a Start up Project.
          </div>
        )}
      </div>

      {archivedProjects.length > 0 && (
        <details className="px-8">
          <summary className="cursor-pointer opacity-70">
            Archived Projects({archivedProjects.length})
          </summary>

          <div className="-mx-2 mt-2">
            <table>
              <tbody>
                {archivedProjects.map((i, index) => (
                  <tr key={index} className="border-y dark:border-gray-800">
                    <td>
                      <Link to={`${i.id}`}>{i.name}</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      )}
    </Page>
  );
};

export default GTMProjectsPage;
